import {get, post} from '../interceptor'

let preUrl = '/energyDisplay';
export default {
  getBigScreenData (params) { return post(preUrl, '/getScreenData', params); },
  getSiteList (params) { return post(preUrl, '/getSiteList', params); },
  getDataDisplay (params) { return post(preUrl, '/getDataDisplay', params); },
  getSiteInfo (params) { return post(preUrl, '/getSiteInfo', params); },
  getEnergyCurve (params) { return post(preUrl, '/getEnergyCurve', params); },
  getSvgList (params) { return post(preUrl, '/getSvgList', params); },
  getSvgFile (params) { return post(preUrl, '/getSvgFile?id=' + params); },
  getDrawData (params) { return post(preUrl, '/getDrawData', params); },
  getDigitalScreenData2 (params) { return get(preUrl, '/getScreenData4', params); },
  getDigitalScreenData1 (params) { return get(preUrl, '/getScreenData3', params); },
  getSiteScreenData (params) { return post(preUrl, '/getScreenData2', params); },
  getSiteEnergyRank (params) { return post(preUrl, '/getSiteEnergyRank', params); },
  getSensorEnergyRank (params) { return post(preUrl, '/getSensorEnergyRank', params); }
}



// WEBPACK FOOTER //
// ./src/api/energy/energyDisplay.js